export const getMean = (numbers: number[]) => {
  let total = 0
  numbers.forEach((num) => (total += num))
  return parseFloat((total / numbers.length).toFixed(2))
}
